<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.testimonial.quote', 'Quote')">
    <UTextarea
      v-model="block.data.quote"
      :rows="3"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.testimonial.author', 'Author')">
    <UInput
      v-model="block.data.author"
      class="w-full"
    />
  </UFormField>
  <UFormField :label="t('site.f.testimonial.role_company', 'Role / company')">
    <UInput
      v-model="block.data.role"
      class="w-full"
    />
  </UFormField>
  <SiteEditorImagePicker
    :label="t('site.f.common.avatar_label', 'Avatar')"
    variant="avatar"
    :model-value="block.data.avatar"
    @update:model-value="block.data.avatar = $event"
  />
</template>
